export default "__VITE_ASSET__CmTKKkV9__"